export default "__VITE_ASSET__9cCTE6T1__"